/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IEstadosDetalles from 'Infotrack@Modelos/smartStock/estadosDetalles/entidades/estadosDetalles';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { connect } from 'react-redux';
import EstadosDetallesCM from '../controladorModelo/estadosDetallesCM';
import { IFormularioEstadosDetallesCVProps } from '../interfaces';
import { acciones, IEstadoEstadosDetalles } from '../reductorEstadosDetalles';
import FormularioEstadosDetallesVista from '../vista/formularioEstadosDetallesVista';
import { useSelector } from 'react-redux';

const estadoInicial: IEstadosDetalles = {
    EmpresaId: '',
    DescripcionEstadoDetalle: '',
    Estado: 1,
    AgenciaId: '',
};
const estadosDetallesCM = new EstadosDetallesCM();

const FormularioEstadosDetallesCV: React.FunctionComponent<IFormularioEstadosDetallesCVProps> = ({ IdEmpresa }) => {
    const idAgencia = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.agenciaActual!.IdAgencia);
    const [{ estadoFormulario, tipoFormulario, entidadEstadosDetalles }, dispatch] = useProveedor<
        IEstadoEstadosDetalles
    >();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<IEstadosDetalles>(estadoInicial);

    React.useEffect(() => {
        if (entidadEstadosDetalles && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadEstadosDetalles);
        } else {
            reiniciar();
        }
    }, [entidadEstadosDetalles]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionEstadosDetalles = () => {
        if (estadosDetallesCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarEstadosDetalles,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarEstadosDetalles = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            estadosDetallesCM
                .crearEstadosDetalles({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        } else {
            estadosDetallesCM
                .editarEstadosDetalles({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        }
    };

    return (
        <FormularioEstadosDetallesVista
            accionCrearEditar={confirmarCreacionEdicionEstadosDetalles}
            cambiarInfoFomulario={alCambiarValor}
            estadosDetalles={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

const estadoAPropiedades = ({
    estadoAutenticacion: { usuarioInformacion },
}: IEstadoGlobal): IFormularioEstadosDetallesCVProps => ({ IdEmpresa: usuarioInformacion!.IdEmpresa });

export default connect<IFormularioEstadosDetallesCVProps, null, any, IEstadoGlobal>(
    estadoAPropiedades,
    null
)(FormularioEstadosDetallesCV);
